import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { MissingInventoryFlagReportListTemplate } from "themes/application/missing-inventory-flag-report/pages";
import { MissingInventoryFlagReportListViewStore } from "application/missing-inventory-flag-report/stores";

@setCurrentView(rootStore => new MissingInventoryFlagReportListViewStore(rootStore), "missingInventoryFlagReportListViewStore")
@observer
class MissingInventoryFlagReportList extends React.Component {
    render() {
        return <MissingInventoryFlagReportListTemplate {...this.props} />;
    }
}

export default MissingInventoryFlagReportList;